<mat-toolbar class="mat-elevation-z8">
  {{ i18n.title | translateAttribute }}
</mat-toolbar>

<mat-dialog-content>
  <div class="container">
    @if (data.problemOrders && data.problemOrders.length > 0) {
      <div class="order-list">
        @for (order of data.problemOrders; track order.orderId) {
          <div class="order-row">
            <div class="order-info" (click)="goToOrder(order.orderId)">
              <span class="order-nr">#{{order.orderNr}}</span>
              @if (order.carId) {
                <span class="order-car-id">{{order.carId}}</span>
              }
              @for (label of getProblemLabels(order.problemFlags); track label) {
                <span class="order-problem-tag">{{label}}</span>
              }
            </div>
            <button mat-stroked-button [disabled]="solvingOrderIds.has(order.orderId)"
              (click)="solveOrder(order, $event)">{{ i18n.solve | translateAttribute }}</button>
          </div>
        }
      </div>
    } @else {
      <div class="no-orders-container">
        <p>{{ i18n.noOrders | translateAttribute }}</p>
      </div>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions class="pe-4 py-3" align="end">
  <button mat-button mat-dialog-close>{{ i18n.close | translateAttribute }}</button>
</mat-dialog-actions>
